import React from 'react';
import { ShieldCheckIcon, ActivityIcon, MapPinIcon, CpuIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center pt-24 pb-12 overflow-hidden bg-ucensys-navy" data-id="element-243">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-circuit-pattern opacity-40 pointer-events-none" data-id="element-244"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-ucensys-teal/20 blur-[120px] rounded-full pointer-events-none" data-id="element-245"></div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-ucensys-navy to-transparent pointer-events-none" data-id="element-246"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex-1 flex flex-col justify-center" data-id="element-247">
        <div className="max-w-4xl mx-auto text-center animate-fade-in-up" data-id="element-248">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-ucensys-card border border-border-color mb-8" data-id="element-249">
            <span className="w-2 h-2 rounded-full bg-ucensys-teal animate-pulse-slow" data-id="element-250"></span>
            <span className="text-sm font-mono text-text-secondary uppercase tracking-wider" data-id="element-251">
              Enterprise AI Infrastructure
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-8" data-id="element-252">
            Power Your Cognitive Applications with Atlanta's{' '}
            <span className="text-ucensys-teal" data-id="element-253">Premier Hybrid Cloud</span>
          </h1>

          <p className="text-lg md:text-xl font-body text-text-secondary mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-254">
            AI infrastructure, machine learning workloads, and hybrid cloud
            solutions — built for the future and designed for enterprise scale.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-20" data-id="element-255">
            <a href="#contact" className="w-full sm:w-auto px-8 py-4 rounded-full bg-teal-gradient text-white font-heading font-semibold hover:shadow-teal-glow-strong transition-all duration-300 text-center" data-id="element-256">
              Get Started
            </a>
            <a href="#data-center" className="w-full sm:w-auto px-8 py-4 rounded-full border-2 border-ucensys-teal text-ucensys-teal font-heading font-semibold hover:bg-ucensys-teal/10 transition-all duration-300 text-center" data-id="element-257">
              Schedule a Tour
            </a>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 pt-12 border-t border-border-color/50 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-258">
          <div className="flex flex-col items-center justify-center text-center p-4" data-id="element-259">
            <ActivityIcon className="w-6 h-6 text-ucensys-teal mb-3" data-id="element-260" />
            <span className="text-2xl font-heading font-bold text-white mb-1" data-id="element-261">
              99.99%
            </span>
            <span className="text-sm font-body text-text-muted" data-id="element-262">
              Uptime Guarantee
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-center p-4" data-id="element-263">
            <ShieldCheckIcon className="w-6 h-6 text-ucensys-teal mb-3" data-id="element-264" />
            <span className="text-2xl font-heading font-bold text-white mb-1" data-id="element-265">
              SSAE 18
            </span>
            <span className="text-sm font-body text-text-muted" data-id="element-266">
              Compliant Facility
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-center p-4" data-id="element-267">
            <MapPinIcon className="w-6 h-6 text-ucensys-teal mb-3" data-id="element-268" />
            <span className="text-2xl font-heading font-bold text-white mb-1" data-id="element-269">
              Atlanta
            </span>
            <span className="text-sm font-body text-text-muted" data-id="element-270">
              Based Infrastructure
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-center p-4" data-id="element-271">
            <CpuIcon className="w-6 h-6 text-ucensys-teal mb-3" data-id="element-272" />
            <span className="text-2xl font-heading font-bold text-white mb-1" data-id="element-273">
              AI-Ready
            </span>
            <span className="text-sm font-body text-text-muted" data-id="element-274">
              GPU Clusters
            </span>
          </div>
        </div>
      </div>
    </section>;
}